// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-labour-container {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 60vh;
}
.private-labour-container form {
  padding-bottom: 0px !important;
}

.private-labour-container-wc {
  max-height: 50vh !important;
}

.slider-container {
  margin: 0;
}

.slider-label {
  padding-top: 23px;
}

.control-validate.ng-touched.ng-invalid, .control-validate.ng-touched.ng-valid {
  background-image: none;
}

.rucLength {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

@media only screen and (max-width: 500px) {
  .private-labour-container {
    max-height: 100vh;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
